<template>
    <div class="curtain-grey">
        <div class="body-option-priority">
            <div class="border-option-priority">
                <div class="text-title">选择优先级</div>
                <ul class="items-priority">
                    <li class="item-priority my-cursor"
                        @click.stop="selected(index+1)"
                        v-for="(item, index) in priorityItems">
                        <div :class="{
                            'icon-option-true': level === index+1,
                            'icon-option-false': level !== index+1,
                        }">
                        </div>
                        <div class="text-priority">{{ item }}</div>
                    </li>
                </ul>
                <div class="button-items">
                    <div class="button-close my-cursor" @click.stop="close">取消</div>
                    <div class="button-submit my-cursor" @click.stop="submit">保存</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "OptionPriority",
    data(){
        return {
            level: 4,
        }
    },
    props: {
        priorityItems: {
            type: Array,
            default: ()=> [],
        },
        priorityLevel: {
            type: Number,
            default: 4,
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent", this.level);
            this.close();
        },
        selected: function(level){
            this.level = level;
        },
    },
    mounted(){
        this.level = this.priorityLevel;
    },
}
</script>

<style scoped>
div.body-option-priority{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}

div.border-option-priority{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.text-title{
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}

ul.items-priority{
    width: 100%;
    max-height: 2rem;
    margin-top: 0.1rem;
    margin-bottom: 0.1rem;
}

li.item-priority{
    width: 100%;
    height: 0.4rem;
    display: flex;
    align-items: center;
    gap: 0.1rem;
}
div.icon-option-true, div.icon-option-false{
    width: 0.22rem;
    height: 0.22rem;

}
div.icon-option-true{
    background: url("../../../assets/images/Public/icon-option-true.png");
    background-size: cover;
}
div.icon-option-false{
    background: url("../../../assets/images/Public/icon-option-false.png");
    background-size: cover;
}
div.text-priority{
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    text-align: left;
}
div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    padding: 0 0.34rem;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>